var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.$props.tag,_vm._g(_vm._b({tag:"component",staticClass:"base-icon"},'component',_vm.$attrs,false),_vm.$listeners),[_c('b-icon',{attrs:{"icon":_vm.$props.icon,"font-scale":_vm.$props.fontScale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }